import { configureStore } from "@reduxjs/toolkit";
import motorMakeStore from "../pages/motorMaster/motor-make/store/motorMakeStore";
import motorBodyTypeStore from "../pages/motorMaster/motor-bodyType/store/motorBodyTypeStore";
import motorModelStore from "../pages/motorMaster/motor-model/store/motorModelStore";
import motorVariantStore from "../pages/motorMaster/motor-variant/store/motorVariantStore";
import motorBodyStyleStore from "../pages/motorMaster/motor-bodyStyle/store/motorBodyStyleStore";
import motorRTOStore from "../pages/motorMaster/motor-RTO/store/motorRTOStore";
import motorCategoryStore from "../pages/motorMaster/motor-category/store/motorCategoryStore";
import motorKeyValueStore from "../pages/motorMaster/motor-keyValue/store/motorKeyValueStore";
import generalInsurerStore from "../pages/generalMaster/general-insurer/store/generalInsureStore";
import generalBankStore from "../pages/generalMaster/bankName/store/index";
import generalFinanceStore from "../pages/generalMaster/finance/store/index";
import generalBranchStore from "../pages/generalMaster/bankBranch/store/index";
import categoryReducer from "../pages/generalMaster/category/reducers/categorySlice";
import generalKeyValueStore from "../pages/generalMaster/category/reducers/categorySlice";
import generalCountryStore from "../pages/generalMaster/country/store/index";
import generalStateStore from "../pages/generalMaster/state/store/index";
import generalDistrictStore from "../pages/generalMaster/district/store/index";
import generalCityStore from "../pages/generalMaster/city/store/index";
import generalPincodeStore from "../pages/generalMaster/pincode/store/index";
import generalAddonStore from "../pages/generalMaster/general-addon/store/index";
import generalCoverageStore from "../pages/generalMaster/general-coverage/store/index";
import generalDiscountStore from "../pages/generalMaster/general-discount/store/index";
import loadingReducer from "../components/Loading/index";
import insurerAddonStore from "../pages/insurerMaster/addon/store/index";
import insurerCoverageStore from "../pages/insurerMaster/coverage/store/index";
import insurerDiscountStore from "../pages/insurerMaster/discount/store/index";
import insurerBankStore from "../pages/insurerMaster/bank/store/index";
import insurerCountryStore from "../pages/insurerMaster/country/store/index";
import insurerStateStore from "../pages/insurerMaster/state/store/index";
import insurerDistrictStore from "../pages/insurerMaster/district/store/index";
import insurerCityStore from "../pages/insurerMaster/city/store/index";
import insurerBankBranchStore from "../pages/insurerMaster/bankBranch/store/index";
import previousInsurerStore from "../pages/insurerMaster/previousInsurer/store/index";
import insurerCategoryStore from "../pages/insurerMaster/category/store/index";
import insurerPincodeStore from "../pages/insurerMaster/pincode/store/index";
import financerStore from "../pages/insurerMaster/financer/store/index";
import rtoStore from "../pages/insurerMaster/rto/store/index";
import insurerBodyTypeStore from "../pages/insurerMaster/bodyType/store/index";
import insurerBodyStyleStore from "../pages/insurerMaster/bodyStyle/store/index";
import insurerMakeReducer from "../pages/insurerMaster/mmv/make/store/index";
import insurerModelReducer from "../pages/insurerMaster/mmv/model/store/index";
import insurerVariantReducer from "../pages/insurerMaster/mmv/variant/store/index";
import transformDictionaryStore from "../pages/ApiIntegrationEngine/TransformFunctionDictionary/store/index";
import schemaStore from "../pages/ApiIntegrationEngine/Schemas/store/index";
import ExternalApiRegistryStore from "../pages/ApiIntegrationEngine/ExternalApiRegistry/store/index";
import apiInsurerApiStore from "../pages/ApiIntegrationEngine/InsurerRegistry/store/index";
import apiFieldDictionaryStore from "../pages/ApiIntegrationEngine/FieldDictionary/store/index";
import apiFieldMappingStore from "../pages/ApiIntegrationEngine/FieldMapping/store/index";
import insurerKeyValueStore from "../pages/insurerMaster/keyValue/store/insurerKeyValueStore";
import operationWorkflowDictionaryStore from "../pages/Operation/WorkflowDictionary/store/index";
import operationWorkflowBindingStore from "../pages/Operation/WorkflowBinding/store/index";
import operationWorkflowStepStore from "../pages/Operation/WorkflowStep/store/index";
import operationCategoryStore from "../pages/Operation/OperationCategory/store/index";
import operationKeyValueStore from "../pages/Operation/OperationStore/store/operationKeyValueStore";
import apiCategoryStore from "../pages/ApiIntegrationEngine/Category/store/index";
import apiKeyValueStore from "../pages/ApiIntegrationEngine/Store/store/index"
import workflowStepDependencyStore from "../pages/Operation/WorkflowStepDependency/store/index";
import APIoperationsStore from "../pages/ApiIntegrationEngine/APIoperations/store/index";
import healthCategoryStore from "../pages/healthMaster/Category/store/index"
import healthKeyValueStore from "../pages/healthMaster/Store/store/healthKeyValueStore"

export const store = configureStore({
  reducer: {
    category: categoryReducer,
    loading: loadingReducer,
    motorMakeStore,
    motorModelStore,
    motorVariantStore,
    motorBodyTypeStore,
    motorBodyStyleStore,
    motorRTOStore,
    motorCategoryStore,
    motorKeyValueStore,
    generalInsurerStore,
    generalBankStore,
    generalFinanceStore,
    generalBranchStore,
    generalKeyValueStore,
    generalCountryStore,
    generalStateStore,
    generalDistrictStore,
    generalCityStore,
    generalPincodeStore,
    generalAddonStore,
    generalCoverageStore,
    generalDiscountStore,
    insurerKeyValueStore,
    insurerAddonStore,
    insurerCoverageStore,
    insurerDiscountStore,
    insurerBankStore,
    insurerCountryStore,
    insurerStateStore,
    insurerDistrictStore,
    insurerCityStore,
    insurerBankBranchStore,
    previousInsurerStore,
    insurerCategoryStore,
    insurerPincodeStore,
    financerStore,
    rtoStore,
    insurerBodyTypeStore,
    insurerBodyStyleStore,
    insurerMakeReducer,
    insurerModelReducer,
    insurerVariantReducer,
    transformDictionaryStore,
    schemaStore,
    ExternalApiRegistryStore,
    apiInsurerApiStore,
    apiFieldDictionaryStore,
    apiFieldMappingStore,
    operationWorkflowDictionaryStore,
    operationWorkflowBindingStore,
    operationWorkflowStepStore,
    operationCategoryStore,
    APIoperationsStore,
    operationKeyValueStore,
    apiCategoryStore,
    apiKeyValueStore,
    workflowStepDependencyStore,
    healthCategoryStore,
    healthKeyValueStore
  },
});
